import { useQuery } from '@tanstack/react-query';
import type {
	MaintenanceMixtureDraft,
	MaintenanceMixtureUsage,
} from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export interface MixtureSectorConcentration extends MaintenanceMixtureUsage {
	sectorId: string;
	sectorName: string;
	unit: 'g/L';
	excludedDefensiveIds: string[];
}

export function useGetMixtureConcentration(
	planId: string,
	products: MaintenanceMixtureDraft['products'],
	enabled: boolean
) {
	const forBinding = useForBindingId();

	return useQuery({
		queryKey: ['maintenance', planId, 'mixture-concentration', forBinding, products],
		enabled: enabled && !!planId && products.length > 0,
		retry: false,
		placeholderData: (previous) => previous,
		queryFn: async () => {
			try {
				const { data } = await api.post<{ concentrations: MixtureSectorConcentration[] }>(
					'/advices/fertilization-plan/mixtures/get-concentration',
					{ planId, products },
					{ params: { forBinding } }
				);
				return data.concentrations;
			} catch (error) {
				throw toApiError(error, 'Erro ao calcular a concentração da mistura');
			}
		},
	});
}
